/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 首页备忘录接口（按账套 + 用户隔离）</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年10月24日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//备忘录列表，默认最新 5 条
	list(limit = 5) {
		return Ajax.get('/memo/list', {limit})
	},
	save(content) {
		return Ajax.postJson('/memo', {content})
	},
	update(id, content) {
		return Ajax.put('/memo', {id, content})
	},
	remove(id) {
		return Ajax.delete('/memo?id=' + id)
	}
}
